// extracted by mini-css-extract-plugin
export default {"right":"FastForwardRewindArrow_right__zu3w+","left":"FastForwardRewindArrow_left__cH723"};